export default __webpack_public_path__ + "static/media/1-6-1.f083f64f.jpg";